import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import WeatherWidgetComponent from './js/weather-widget.component';

ComponentsFactory.getInstance().define('weather-widget', WeatherWidgetComponent);
